import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ToursPage = lazy(() => import('../pages/tours/page'));
const TransfersPage = lazy(() => import('../pages/transfers/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const PaymentSuccessPage = lazy(() => import('../pages/payment-success/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/tours',
    element: <ToursPage />,
  },
  {
    path: '/transfers',
    element: <TransfersPage />,
  },
  {
    path: '/booking',
    element: <BookingPage />,
  },
  {
    path: '/payment-success',
    element: <PaymentSuccessPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
